import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Quagga from 'quagga'; // ES6
import { take } from 'rxjs/operators';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-cd001-card-guide',
    templateUrl: './cd001-card-guide.component.html',
    styleUrls: ['./cd001-card-guide.component.scss']
})
export class Cd001CardGuideComponent implements OnInit {

    public listCd006OnLote?: Array<any> = new Array<any>();

    public presencaSabugoPedunculo?: string;
    public presencaPoExcesso?: string;
    public loteDs?: string;
    public presencaFundo?: string;
    public diferencaPesoHectolitrico?: number;
    public pesoSabugoPonderado?: number;
    public tipoColheitaGranel = false;

    public enableSabugo = false;
    public enableSabugoI = false;
    public enableSabugoII = false;
    public enableSabugoIII = false;    
    public enablePo = false;
    public enableFundo = false;
    public enablePesoMaior = false;
    public enablePesoMenor = false;
    public enableOk = false;

    constructor(
        public dialogRef: MatDialogRef<Cd001CardGuideComponent>,
        protected formularioService: FormularioService,
        protected notificationService: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    async ngOnInit(): Promise<void> {
        this.presencaSabugoPedunculo = this.data?.presencaSabugoPedunculo;
        this.presencaPoExcesso = this.data?.presencaPoExcesso;
        this.presencaFundo = this.data?.presencaFundo;
        this.diferencaPesoHectolitrico = this.data?.diferencaPesoHectolitrico;
        this.loteDs = this.data?.loteDs;
        await this.getCd006ByLoteDs();
    }

    async closeModal(): Promise<void> {
        this.dialogRef.close();
    }

    async enableTexts(): Promise<void> {
        if (!!this.presencaSabugoPedunculo && this.presencaSabugoPedunculo == 'SIM') {
            this.enableSabugo = true;
        }

        if (this.tipoColheitaGranel && (!!this.pesoSabugoPonderado && Math.abs(this.pesoSabugoPonderado) > 1)) {
            this.enableSabugoI = true;
        }
        else if (!!this.pesoSabugoPonderado && Math.abs(this.pesoSabugoPonderado) > 1) {
            this.enableSabugoII = true;
        }
        else if (this.tipoColheitaGranel) {
            this.enableSabugoIII = true;
        }

        if (!!this.presencaPoExcesso && this.presencaPoExcesso == 'SIM') {
            this.enablePo = true;
        }

        if (!!this.presencaFundo && this.presencaFundo == 'SIM') {
            this.enableFundo = true;
        }

        if (this.diferencaPesoHectolitrico != null && this.diferencaPesoHectolitrico > 16) {
            this.enablePesoMaior = true;
        }

        if (this.diferencaPesoHectolitrico != null && this.diferencaPesoHectolitrico < 8) {
            this.enablePesoMenor = true;
        }

        if (!this.enableSabugo && !this.enableSabugoI && !this.enableSabugoII && !this.enableSabugoIII
            && !this.enablePo && !this.enableFundo 
            && !this.enablePesoMaior && !this.enablePesoMenor) {
            this.enableOk = true;
        }

    }

    async getCd006ByLoteDs(event?: any): Promise<void> {
        await this.formularioService.getCd006DataByLoteDs(this.loteDs).pipe(take(1)).toPromise().then(async (objcd006: any) => {
            this.listCd006OnLote = objcd006?.data;
            if (!!this.listCd006OnLote && this.listCd006OnLote.length > 0)
            {
                await this.getPesoMedioPonderado();
                await this.enableTexts(); 
            }
            else
                await this.enableTexts();
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes ao lote ${this.loteDs}. Entre em contato com o Administrador.`);
        });
    }

    private async getPesoMedioPonderado(): Promise<void> {
        var totalVolumeDs: number = 0;
        var totalPesoSabugoPond: number = 0;

        // tslint:disable-next-line: max-line-length
        this.listCd006OnLote.forEach(element => {
            var volumeDs: number = element.volume_ds;
            var pesoSabugo: number = element.peso_sabugo_penduculo;
            var tipoColheita: string = element.tipo_colheita;
            if (!!tipoColheita && tipoColheita.toUpperCase() == 'GRANEL')
                this.tipoColheitaGranel = true;

            if (volumeDs !== null && pesoSabugo !== null) {
                totalPesoSabugoPond += (+pesoSabugo) * (+volumeDs);
                totalVolumeDs += +volumeDs
            }
        });

        this.pesoSabugoPonderado = totalPesoSabugoPond/totalVolumeDs;
    }
}
